import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import HeroBanner from './HeroBanner';
import ScrollToTop from './ScrollToTop';
import ScrollReveal from './ScrollReveal';
import StatsCounter from './StatsCounter';
import ContactForm from './ContactForm';

const Home = () => {
  return (
    <>
      <Navbar />
      <HeroBanner />
      <ScrollToTop />

      <section id="products" className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="container mx-auto px-6 sm:px-8 lg:px-12">
          <ScrollReveal animation="fade-up">
            <div className="text-center mb-16">
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                Os Nossos Produtos/<span className="text-primary-600">Serviços</span>
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-primary-500 to-primary-600 mx-auto rounded-full mb-6"></div>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                Soluções tecnológicas inovadoras para transformar a gestão dos seus espaços verdes
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10 max-w-7xl mx-auto">
            <ScrollReveal animation="fade-up" delay={0.1}>
              <Link to="/cadernos" className="group block h-full">
                <div className="bg-white rounded-2xl shadow-soft-md hover:shadow-soft-xl transition-all duration-500 overflow-hidden h-full flex flex-col transform hover:-translate-y-2 border border-gray-100 hover:border-primary-200">
                  <div className="relative overflow-hidden bg-gradient-to-br from-primary-50 to-primary-100/50 aspect-[4/3]">
                    <img
                      src="/cadernos.png"
                      alt="Cadernos de Campo Digitais"
                      loading="lazy"
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  </div>
                  <div className="p-8 flex flex-col flex-1">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-primary-600 transition-colors duration-300">
                      Cadernos de Campo Digitais
                    </h3>
                    <p className="text-gray-600 leading-relaxed mb-6 flex-1">
                      Registe e acompanhe todas as suas atividades de campo de forma digital, prática e organizada.
                    </p>
                    <div className="flex items-center text-primary-600 font-semibold group-hover:gap-3 gap-2 transition-all duration-300">
                      <span>Saiba Mais</span>
                      <svg className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                      </svg>
                    </div>
                  </div>
                </div>
              </Link>
            </ScrollReveal>

            <ScrollReveal animation="fade-up" delay={0.2}>
              <Link to="/rega" className="group block h-full">
                <div className="bg-white rounded-2xl shadow-soft-md hover:shadow-soft-xl transition-all duration-500 overflow-hidden h-full flex flex-col transform hover:-translate-y-2 border border-gray-100 hover:border-primary-200">
                  <div className="relative overflow-hidden bg-gradient-to-br from-blue-50 to-blue-100/50 aspect-[4/3]">
                    <img
                      src="/sensor.png"
                      alt="Rega Inteligente"
                      loading="lazy"
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  </div>
                  <div className="p-8 flex flex-col flex-1">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-primary-600 transition-colors duration-300">
                      Rega Inteligente
                    </h3>
                    <p className="text-gray-600 leading-relaxed mb-6 flex-1">
                      Sistema automatizado para rega eficiente, economizando água e mantendo os espaços verdes saudáveis.
                    </p>
                    <div className="flex items-center text-primary-600 font-semibold group-hover:gap-3 gap-2 transition-all duration-300">
                      <span>Saiba Mais</span>
                      <svg className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                      </svg>
                    </div>
                  </div>
                </div>
              </Link>
            </ScrollReveal>

            <ScrollReveal animation="fade-up" delay={0.3}>
              <Link to="/energia" className="group block h-full">
                <div className="bg-white rounded-2xl shadow-soft-md hover:shadow-soft-xl transition-all duration-500 overflow-hidden h-full flex flex-col transform hover:-translate-y-2 border border-gray-100 hover:border-primary-200">
                  <div className="relative overflow-hidden bg-gradient-to-br from-yellow-50 to-yellow-100/50 aspect-[4/3]">
                    <img
                      src="/energia.png"
                      alt="Energia Inteligente"
                      loading="lazy"
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  </div>
                  <div className="p-8 flex flex-col flex-1">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-primary-600 transition-colors duration-300">
                      Energia Inteligente
                    </h3>
                    <p className="text-gray-600 leading-relaxed mb-6 flex-1">
                      Otimize o consumo de energia nas suas explorações agrícolas com monitorização em tempo real e recomendações automáticas.
                    </p>
                    <div className="flex items-center text-primary-600 font-semibold group-hover:gap-3 gap-2 transition-all duration-300">
                      <span>Saiba Mais</span>
                      <svg className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                      </svg>
                    </div>
                  </div>
                </div>
              </Link>
            </ScrollReveal>
          </div>
        </div>
      </section>

      <StatsCounter />

      <section id="about" className="py-20 bg-gradient-to-br from-gray-50 via-white to-gray-50">
        <div className="container mx-auto px-6 sm:px-8 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center max-w-7xl mx-auto">
            <ScrollReveal animation="fade-right">
              <div>
                <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                  Sobre a <span className="text-primary-600">Vulpes</span>
                </h2>
                <div className="w-24 h-1 bg-gradient-to-r from-primary-500 to-primary-600 rounded-full mb-8"></div>

                <p className="text-lg text-gray-700 leading-relaxed mb-6">
                  Na Vulpes, acreditamos que a <strong className="text-primary-600">tecnologia só faz sentido quando simplifica o quotidiano</strong> e gera resultados mensuráveis.
                </p>

                <p className="text-lg text-gray-700 leading-relaxed mb-6">
                  Por isso, desenvolvemos soluções que combinam <strong className="text-primary-600">inteligência artificial, automação e interoperabilidade</strong>.
                </p>

                <p className="text-lg text-gray-700 leading-relaxed mb-8">
                  O nosso objetivo é único: <strong className="text-primary-600">eficiência e sustentabilidade</strong> da gestão de rega aos cadernos de campo digitais, passando pela energia.
                </p>

                <div className="flex flex-wrap gap-4">
                  <div className="flex items-center gap-3 bg-white px-6 py-3 rounded-xl shadow-soft-md border border-gray-100">
                    <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-primary-600 rounded-lg flex items-center justify-center flex-shrink-0">
                      <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <span className="font-semibold text-gray-900">Inovação Contínua</span>
                  </div>

                  <div className="flex items-center gap-3 bg-white px-6 py-3 rounded-xl shadow-soft-md border border-gray-100">
                    <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-green-600 rounded-lg flex items-center justify-center flex-shrink-0">
                      <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <span className="font-semibold text-gray-900">Foco no Cliente</span>
                  </div>

                  <div className="flex items-center gap-3 bg-white px-6 py-3 rounded-xl shadow-soft-md border border-gray-100">
                    <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                      <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <span className="font-semibold text-gray-900">Resultados Reais</span>
                  </div>
                </div>
              </div>
            </ScrollReveal>

            <ScrollReveal animation="fade-left" delay={0.2}>
              <div className="relative">
                <div className="grid grid-cols-2 gap-6">
                  <div className="bg-gradient-to-br from-primary-500 to-primary-600 rounded-2xl p-8 text-white shadow-soft-xl transform hover:-translate-y-2 transition-all duration-300">
                    <div className="text-5xl font-bold mb-2">250+</div>
                    <div className="text-primary-100 font-medium">Clientes Satisfeitos</div>
                  </div>

                  <div className="bg-white rounded-2xl p-8 shadow-soft-xl border border-gray-100 transform hover:-translate-y-2 transition-all duration-300 mt-8">
                    <div className="text-5xl font-bold text-primary-600 mb-2">24/7</div>
                    <div className="text-gray-600 font-medium">Suporte Técnico</div>
                  </div>

                  <div className="bg-white rounded-2xl p-8 shadow-soft-xl border border-gray-100 transform hover:-translate-y-2 transition-all duration-300 -mt-8">
                    <div className="text-5xl font-bold text-primary-600 mb-2">3</div>
                    <div className="text-gray-600 font-medium">Soluções Premium</div>
                  </div>

                  <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-2xl p-8 text-white shadow-soft-xl transform hover:-translate-y-2 transition-all duration-300">
                    <div className="text-5xl font-bold mb-2">99%</div>
                    <div className="text-green-100 font-medium">Taxa de Sucesso</div>
                  </div>
                </div>

                <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-primary-100 rounded-full blur-3xl opacity-50 -z-10"></div>
                <div className="absolute -top-4 -left-4 w-32 h-32 bg-green-100 rounded-full blur-3xl opacity-50 -z-10"></div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* Benefícios Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6 sm:px-8 lg:px-12">
          <ScrollReveal animation="fade-up">
            <div className="text-center mb-16">
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                Porquê Escolher a <span className="text-primary-600">Vulpes</span>?
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-primary-500 to-primary-600 mx-auto rounded-full"></div>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
            <ScrollReveal animation="fade-up" delay={0.1}>
              <div className="text-center p-6 rounded-xl hover:bg-gray-50 transition-colors duration-300">
                <div className="w-16 h-16 bg-gradient-to-br from-primary-500 to-primary-600 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-soft-md">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Eficiência</h3>
                <p className="text-gray-600">Automatização inteligente que reduz custos e otimiza recursos</p>
              </div>
            </ScrollReveal>

            <ScrollReveal animation="fade-up" delay={0.2}>
              <div className="text-center p-6 rounded-xl hover:bg-gray-50 transition-colors duration-300">
                <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-soft-md">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Sustentabilidade</h3>
                <p className="text-gray-600">Soluções eco-friendly que preservam o meio ambiente</p>
              </div>
            </ScrollReveal>

            <ScrollReveal animation="fade-up" delay={0.3}>
              <div className="text-center p-6 rounded-xl hover:bg-gray-50 transition-colors duration-300">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-soft-md">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Confiabilidade</h3>
                <p className="text-gray-600">Tecnologia robusta e suporte técnico especializado</p>
              </div>
            </ScrollReveal>

            <ScrollReveal animation="fade-up" delay={0.4}>
              <div className="text-center p-6 rounded-xl hover:bg-gray-50 transition-colors duration-300">
                <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-600 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-soft-md">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Mobilidade</h3>
                <p className="text-gray-600">Acesso remoto e gestão em tempo real de qualquer lugar</p>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-primary-600 via-primary-500 to-primary-600">
        <div className="container mx-auto px-6 sm:px-8 lg:px-12">
          <ScrollReveal animation="zoom-in">
            <div className="text-center max-w-3xl mx-auto">
              <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
                Pronto para Transformar a Sua Gestão?
              </h2>
              <p className="text-xl text-white/90 mb-8">
                Junte-se às empresas que já confiam na Vulpes para otimizar os seus processos
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="#contact"
                  className="inline-flex items-center justify-center gap-2 bg-white text-primary-600 px-8 py-4 rounded-xl font-bold text-lg shadow-soft-xl hover:shadow-glow-lg transform hover:-translate-y-1 transition-all duration-300"
                >
                  <span>Fale Connosco</span>
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </a>
                <Link
                  to="/faq"
                  className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 px-8 py-4 rounded-xl font-bold text-lg hover:bg-white/20 transition-all duration-300"
                >
                  <span>Saber Mais</span>
                </Link>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>

      <section id="contact" className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="container mx-auto px-6 sm:px-8 lg:px-12">
          <ScrollReveal animation="fade-up">
            <div className="text-center mb-16">
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                Entre em <span className="text-primary-600">Contacto</span>
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-primary-500 to-primary-600 mx-auto rounded-full mb-6"></div>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Estamos prontos para ajudar a transformar o seu negócio. Fale connosco!
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto mb-12">
            <ScrollReveal animation="fade-up" delay={0.1}>
              <div className="bg-white rounded-2xl p-8 shadow-soft-md hover:shadow-soft-xl transition-all duration-300 border border-gray-100 text-center group">
                <div className="w-16 h-16 bg-gradient-to-br from-primary-500 to-primary-600 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 shadow-soft-md">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Telefone</h3>
                <a href="tel:+351969059898" className="text-primary-600 hover:text-primary-700 font-semibold text-lg transition-colors duration-200">
                  +351 969 059 898
                </a>
                <br></br>
                <p className="text-gray-500 text-sm mt-2">Chamada para rede móvel nacional</p>
              </div>
            </ScrollReveal>

            <ScrollReveal animation="fade-up" delay={0.2}>
              <div className="bg-white rounded-2xl p-8 shadow-soft-md hover:shadow-soft-xl transition-all duration-300 border border-gray-100 text-center group">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 shadow-soft-md">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Email</h3>
                <a href="mailto:hello@vulpes.pt" className="text-primary-600 hover:text-primary-700 font-semibold text-lg transition-colors duration-200">
                  comercial@vulpes.pt
                </a>
                <br></br>
                <p className="text-gray-500 text-sm mt-2">Resposta em 24 horas</p>
              </div>
            </ScrollReveal>

            <ScrollReveal animation="fade-up" delay={0.3}>
              <div className="bg-white rounded-2xl p-8 shadow-soft-md hover:shadow-soft-xl transition-all duration-300 border border-gray-100 text-center group">
                <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 shadow-soft-md">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Localização</h3>
                <p className="text-primary-600 font-semibold text-lg mb-1">
                  Centro de Inovação Empresarial da Covilhã
                </p>
                <p className="text-gray-600 text-base">
                  Covilhã, Portugal
                </p>
              </div>
            </ScrollReveal>
          </div>

          <ScrollReveal animation="fade-up" delay={0.4}>
            <div className="max-w-3xl mx-auto">
              <div className="bg-white rounded-2xl shadow-soft-lg p-8 md:p-12 border border-gray-100">
                <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center">Envie-nos uma Mensagem</h3>
                <p className="text-gray-600 text-center mb-8">Preencha o formulário e entraremos em contacto consigo brevemente</p>
                <ContactForm />
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Home;
